import React from 'react';
import { Fade, Backdrop, Modal } from '@material-ui/core';

export interface IModalData {
    headerTitle: string;
    showModal: boolean;
    form?: JSX.Element;
    showModalCallback: Function;
    fixedFooter?: boolean;
}

export function ModalV2(props: IModalData) {
    const { headerTitle, showModal, form, showModalCallback, fixedFooter } = props;

    const handleClose = () => { showModalCallback(false); };

    return (
        <>
            <Modal
                aria-labelledby='transition-modal-title'
                aria-describedby='transition-modal-description'
                className='modal'
                open={showModal}
                onClose={handleClose}
                closeAfterTransition
                disableBackdropClick
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Fade in={showModal}>
                    <div className={`modal__wrapper modal__wrapper-lg ${fixedFooter ? 'modal__wrapper-bottom-padding' : ''}`}>
                        <div className='modal__header'>
                            <h3>{headerTitle}</h3>
                        </div>
                        <div className={`modal__body modal__body--borderless ${fixedFooter ? 'modal__body-fixed-footer' : ''}`}>
                            {form}
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    );
}
